module.exports = __webpack_public_path__ + "img/2.a0384e22.png";